import { render, staticRenderFns } from "./Welcome-ims.vue?vue&type=template&id=489be7d1&"
import script from "./Welcome-ims.vue?vue&type=script&lang=js&"
export * from "./Welcome-ims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports